import React from 'react';
import PropTypes from 'prop-types';
import { Link, Stack, Typography } from '@mui/material';
import { separateArtistsByRole, getArtistUrl } from '../utils/artistUtils';

const ArtistsName = ({
  artists,
  linkColor,
  underline,
  direction = 'column',
  identifiedArtistName,
  identifiedArtistId,
}) => {
  const { producers, feat } = separateArtistsByRole(artists);

  return (
    <Stack spacing={{ xs: 0, md: 1 }} direction={direction}>
      {producers.map((artist, index) => (
        <Stack key={artist.artist_meta?.id} direction={'row'} spacing={1}>
          <Link
            href=""
            to={getArtistUrl(artist)}
            sx={{
              color: linkColor || '#fff',
              textDecorationColor: linkColor || '#fff',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
            underline={underline || 'always'}
          >
            {artist.artist_meta?.name}
          </Link>
          {index < producers.length - 1 && (
            <Typography variant="caption" sx={{ color: linkColor || '#fff' }}>
              {'& '}
            </Typography>
          )}
        </Stack>
      ))}
      {feat.length > 0 && (
        <Stack direction={'row'} spacing={1}>
          <Typography variant="caption" sx={{ color: linkColor || '#fff' }}>
            feat.
          </Typography>
          {feat.map((artist, index) => (
            <Stack key={artist.artist_meta?.id} direction={'row'} spacing={1}>
              <Link
                href=""
                to={getArtistUrl(artist)}
                sx={{
                  color: linkColor || '#fff',
                  textDecorationColor: linkColor || '#fff',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}
                underline={underline || 'always'}
              >
                {artist.artist_meta?.name}
              </Link>
              {index < feat.length - 1 && (
                <Typography
                  variant="caption"
                  sx={{ color: linkColor || '#fff' }}
                >
                  {'& '}
                </Typography>
              )}
            </Stack>
          ))}
        </Stack>
      )}
      {identifiedArtistName && (
        <Stack direction={'row'} spacing={1}>
          <Typography
            variant="caption"
            sx={{ color: linkColor || '#fff', mx: 1 }}
          >
            →
          </Typography>
          {identifiedArtistId ? (
            <Link
              href=""
              to={`/artists/${identifiedArtistId}`}
              sx={{
                color: linkColor || '#fff',
                textDecorationColor: linkColor || '#fff',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }}
              underline={underline || 'always'}
            >
              {identifiedArtistName}
            </Link>
          ) : (
            <Typography sx={{ color: linkColor || '#fff' }}>
              {identifiedArtistName}
            </Typography>
          )}
        </Stack>
      )}
    </Stack>
  );
};

ArtistsName.propTypes = {
  artists: PropTypes.array,
  linkColor: PropTypes.string,
  underline: PropTypes.string,
  direction: PropTypes.string,
  identifiedArtistName: PropTypes.string,
  identifiedArtistId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default ArtistsName;
